import { Link } from 'react-router-dom';

export function Hero() {
  return (
    <div className="text-center py-8 px-4 max-w-2xl mx-auto">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4">
        What size air purifier do you need?
      </h1>
      <p className="text-base sm:text-lg text-muted-foreground">
        Enter your room and concern. You get the clean-air target with the maths shown, and only the
        setups whose sourced numbers actually meet it. Free, no account, no ads, no affiliate links.
      </p>
      <p className="text-sm text-muted-foreground mt-3">
        <Link to="/methodology" className="text-primary underline">How it works</Link> ·{' '}
        <Link to="/corrections" className="text-primary underline">Corrections log</Link>
      </p>
    </div>
  );
}
